import { HttpHeaders } from '@angular/common/http';
import { DocumentResponse } from '@models/documentResponse.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  public urlApi: string;
  public userToken: string;

  constructor(private http: HttpClient) {
    this.urlApi = environment.urlApi;
    this.readToken();
  }

  readToken() {
    if (sessionStorage.getItem('tokenCF')) {
      this.userToken = sessionStorage.getItem('tokenCF');
    } else {
      this.userToken = "";
    }
    return this.userToken;
  }

  get readTokenAlt() {
    if (sessionStorage.getItem('tokenALT')) {
      return sessionStorage.getItem('tokenALT');
    } else {
      return '';
    }
  }

  getDocuments() {
    const headers = new HttpHeaders().set('token', environment.postgres ? this.readTokenAlt : this.userToken);;
    const options = {
      headers
    };
    let idRol = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')).userInfo.ROL_USUARIO : "0";
    if (idRol != "0") {
      options['params'] = {"id_rol": idRol};
    }
    return this.http.get(`${this.urlApi}/listado_documentos`, options).pipe(
      map((resp: any) => {
         let documents: Array<DocumentResponse> = [];
         documents = resp['DOCUMENTOS'] && resp['DOCUMENTOS'].length > 0
                   ? resp['DOCUMENTOS'].map((document: DocumentResponse) => DocumentResponse.fromResponse(document))
                   : [];
         return documents;
      })
    );
    
  }
}
